import { ScatterWinLandscapeProperties } from "../landscape/ScatterWinLandscapeProperties";
export class ScatterWinPortraitProperties extends ScatterWinLandscapeProperties {
    setDefaultValues() {
        super.setDefaultValues();
        this.position.set(490, 1000);
        this.scale.set(1);
    }
}
